import { render, staticRenderFns } from "./loginIdt.vue?vue&type=template&id=057e1d4e"
import script from "./loginIdt.vue?vue&type=script&lang=js"
export * from "./loginIdt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports